/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GroupUptimeValue } from "./GroupUptimeValue";
import {
    GroupUptimeValueFromJSON,
    GroupUptimeValueFromJSONTyped,
    GroupUptimeValueToJSON,
} from "./GroupUptimeValue";

/**
 *
 * @export
 * @interface DateCentricUptimeTrendItem
 */
export interface DateCentricUptimeTrendItem {
    /**
     * The date for this data point
     * @type {Date}
     * @memberof DateCentricUptimeTrendItem
     */
    date?: Date;
    /**
     * Dictionary of group ID to uptime values
     * @type {{ [key: string]: GroupUptimeValue; }}
     * @memberof DateCentricUptimeTrendItem
     */
    groups?: { [key: string]: GroupUptimeValue };
}

/**
 * Check if a given object implements the DateCentricUptimeTrendItem interface.
 */
export function instanceOfDateCentricUptimeTrendItem(
    value: object,
): value is DateCentricUptimeTrendItem {
    return true;
}

export function DateCentricUptimeTrendItemFromJSON(
    json: any,
): DateCentricUptimeTrendItem {
    return DateCentricUptimeTrendItemFromJSONTyped(json, false);
}

export function DateCentricUptimeTrendItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DateCentricUptimeTrendItem {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        groups:
            json["groups"] == null
                ? undefined
                : mapValues(json["groups"], GroupUptimeValueFromJSON),
    };
}

export function DateCentricUptimeTrendItemToJSON(
    value?: DateCentricUptimeTrendItem | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        groups:
            value["groups"] == null
                ? undefined
                : mapValues(value["groups"], GroupUptimeValueToJSON),
    };
}
